// extracted by mini-css-extract-plugin
export default {"password":"PasswordChange_password__TBzs+","warning":"PasswordChange_warning__fgVpH","submit":"PasswordChange_submit__430Yv"};